// ./src/components/features/Forms/FormFieldsEditModal/DateFieldOptionsEditor.tsx
import React from "react";
import { Stack, Text, Group } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import dayjs from "dayjs";
import { DateFieldOptions } from "./fieldOptionsTypes";

export interface DateFieldOptionsEditorProps {
  value: DateFieldOptions;
  onChange: (options: DateFieldOptions) => void;
  isBirthdate?: boolean;
}

// Helper to parse YYYY-MM-DD string to Date for DateInput value prop
const parseDate = (dateStr: string | undefined): Date | null => {
  if (!dateStr) return null;
  const parsed = dayjs(dateStr, "YYYY-MM-DD");
  return parsed.isValid() ? parsed.toDate() : null;
};

export const DateFieldOptionsEditor: React.FC<DateFieldOptionsEditorProps> = ({
  value,
  onChange,
  isBirthdate = false,
}) => {
  // DateInput onChange returns string in "YYYY-MM-DD" format or null
  const handleMinDateChange = (dateStr: string | null) => {
    onChange({
      ...value,
      minDate: dateStr || undefined,
    });
  };

  const handleMaxDateChange = (dateStr: string | null) => {
    onChange({
      ...value,
      maxDate: dateStr || undefined,
    });
  };

  const minDateParsed = parseDate(value.minDate);

  return (
    <Stack gap="sm">
      <Text size="xs" c="dimmed">
        {isBirthdate
          ? "Set allowed date range for birthdate (e.g., for age restrictions)."
          : "Set allowed date range for this field."}
      </Text>

      <Group grow>
        <DateInput
          label="Minimum Date"
          placeholder="No minimum"
          valueFormat="YYYY-MM-DD"
          value={parseDate(value.minDate)}
          onChange={handleMinDateChange}
          clearable
          size="sm"
        />

        <DateInput
          label="Maximum Date"
          placeholder="No maximum"
          valueFormat="YYYY-MM-DD"
          value={parseDate(value.maxDate)}
          onChange={handleMaxDateChange}
          clearable
          minDate={minDateParsed ?? undefined}
          size="sm"
        />
      </Group>
    </Stack>
  );
};
